import { render } from "./ClusterTopMatter.vue?vue&type=template&id=7308d479&ts=true"
import script from "./ClusterTopMatter.vue?vue&type=script&lang=ts"
export * from "./ClusterTopMatter.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__